module.exports = __webpack_public_path__ + "static/assets/083c7c5ca16d24951c8be2894686b8fa.svg";